// "?" in the nav bar: replays the tour for the page on screen. Renders nothing
// on a page without one, so the bars never offer a tour that would not start.
import React from "react";
import { HelpCircle } from "lucide-react";
import { useActiveTour } from "../../tours/activeTour";

function TourButton() {
  const start = useActiveTour();
  if (!start) return null;

  return (
    <button
      onClick={() => start()}
      aria-label="Show me around this page"
      style={{
        display: "flex", alignItems: "center", justifyContent: "center",
        width: 44, height: 44, border: "none", background: "none",
        cursor: "pointer", padding: 0, color: "var(--color-text-strong)",
        WebkitTapHighlightColor: "transparent",
      }}
    >
      <HelpCircle size={21} strokeWidth={1.8} />
    </button>
  );
}

export default TourButton;
